<ion-content [ngClass]="theme">
  <div class="view-frame">
    <div class="bg-container bg-container-fill-margin-top margin-top-status-bar"
      [photoBg]="{fade: false, fadeClass: 'bg-container-fade', url: backgroundSrc}">
      <div class="content">
        <div>

          <ion-fab vertical="top" horizontal="end" class="margin-top-fab">
            <ion-fab-button (click)="showLangOptions()" class="round-fab round-fab-size button-color-primary-70">
              <!-- <ion-icon name="search-outline"></ion-icon> -->
              <icon-wrapper [icon]="langIcon" [custom]="true"></icon-wrapper>
            </ion-fab-button>
          </ion-fab>

          <div class="stick-bottom padding-null" *ngIf="isWeb">
            <div class="text-center padding-xs">
              <span class="info-text-s bold text-color">LP Connect Web</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>